import { LoyaltyCartState } from "../../services/redux/types/LoyaltyCartTypes";
import {
  LoyaltyOfferStatus,
  OrderCartV2Line,
  OrderCartV2Output,
} from "../../services/redux/types/OrderCartV2Types";
import { clearLoyaltyRedemption } from "../../services/redux/utils/loyaltyCartHelpers";

/** Line IDs selected for the active offer — result.selections first, then pre-calculate fallback. */
export function getOfferSelectionLineIds(
  loyalty: Pick<LoyaltyCartState, "redemption" | "result">
): string[] {
  const fromResult = loyalty.result?.appliedOffer?.selections;
  if (fromResult?.length) {
    return fromResult.map((s) => s.lineId);
  }

  const fallback = new Set<string>();
  loyalty.redemption?.pendingSelections?.forEach((s) => fallback.add(s.lineId));
  loyalty.redemption?.addedLineIds?.forEach((id) => fallback.add(id));

  return Array.from(fallback);
}

/** Line IDs to drop on removeLoyaltyOffer / INVALID — same set as offer selections. */
export function getOfferRemovalLineIds(loyalty: LoyaltyCartState): Set<string> {
  return new Set(getOfferSelectionLineIds(loyalty));
}

/**
 * Applies cart-level offer status from calculate response.
 * INVALID clears redemption and strips offer selection lines.
 */
export function applyCartOfferResponseStatus(
  loyalty: LoyaltyCartState,
  result: OrderCartV2Output,
  orderLines: OrderCartV2Line[]
): OrderCartV2Line[] {
  if (result.appliedOffer?.status !== LoyaltyOfferStatus.INVALID) {
    return orderLines;
  }

  const lineIdsToRemove = getOfferRemovalLineIds({ ...loyalty, result });
  clearLoyaltyRedemption(loyalty);

  if (lineIdsToRemove.size === 0) {
    return orderLines;
  }

  return orderLines.filter(
    (line) => !line.lineId || !lineIdsToRemove.has(line.lineId)
  );
}
